import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

const deleteFile = (assetId: string) => FetchPromise.delete(`${CMS_API_ROOT_URL}/file/${assetId}`);

export const useDeleteFile = () => useMutation(deleteFile);
